import React from "react";
import {
  Gamepad2,
  Joystick,
  Monitor,
  Cpu,
  Speaker,
  Dice5,
  Target,
  Tent,
  Headphones,
  Keyboard,
  Mouse,
  Trophy,
  Zap,
  Layout,
  Layers,
  BookOpen,
  Users,
  Tv,
  Wifi,
  Package,
} from "lucide-react";

export interface CategoryItem {
  id: number;
  name: string;
  icon: React.ComponentType<{ size?: number; color?: string }>;
  parentId?: number | null;
  color?: string;
   image?: any;
}

export const idGamingCategories: CategoryItem[] = [
  { id: 60000001, name: "Console Gaming",         icon: Gamepad2,   color: "#7B5CF5" },
  { id: 60000002, name: "PC Gaming",              icon: Monitor,    color: "#4A2D9E" },
  { id: 60000003, name: "Mobile Gaming",          icon: Cpu,        color: "#7B5CF5" },
  { id: 60000004, name: "Gaming Accessories",     icon: Headphones, color: "#A78BFA" },
  { id: 60000005, name: "Gaming Furniture",       icon: Layout,     color: "#4A2D9E" },
  { id: 60000006, name: "VR & AR",                icon: Joystick,   color: "#7B5CF5" },
  { id: 60000007, name: "Board & Card Games",     icon: Dice5,      color: "#A78BFA" },
  { id: 60000008, name: "Indoor Sports Games",    icon: Trophy,     color: "#4A2D9E" },
  { id: 60000009, name: "Outdoor Games & Sports", icon: Target,     color: "#7B5CF5" },
  { id: 60000010, name: "Kids & Family Games",    icon: Users,      color: "#A78BFA" },
];

export const idGamingSubcategories: CategoryItem[] = [
  { id: 60000101, parentId: 60000001, name: "Consoles",              icon: Gamepad2   },
  { id: 60000102, parentId: 60000001, name: "Console Games",         icon: Layers     },
  { id: 60000103, parentId: 60000001, name: "Controllers",           icon: Joystick   },

  { id: 60000201, parentId: 60000002, name: "Gaming PCs & Laptops",  icon: Cpu        },
  { id: 60000202, parentId: 60000002, name: "PC Games",              icon: Tv         },
  { id: 60000203, parentId: 60000002, name: "PC Peripherals",        icon: Keyboard   },

  { id: 60000301, parentId: 60000003, name: "Mobile Games",          icon: Zap        },
  { id: 60000302, parentId: 60000003, name: "Mobile Controllers",    icon: Gamepad2   },

  { id: 60000401, parentId: 60000004, name: "Headsets & Audio",      icon: Headphones },
  { id: 60000402, parentId: 60000004, name: "Keyboards & Mice",      icon: Mouse      },
  { id: 60000403, parentId: 60000004, name: "Streaming Gear",        icon: Wifi       },

  { id: 60000501, parentId: 60000005, name: "Gaming Chairs",         icon: Layout     },
  { id: 60000502, parentId: 60000005, name: "Gaming Desks",          icon: Monitor    },

  { id: 60000601, parentId: 60000006, name: "VR Headsets",           icon: Joystick   },
  { id: 60000602, parentId: 60000006, name: "VR Games",              icon: Layers     },

  { id: 60000701, parentId: 60000007, name: "Board Games",           icon: Dice5      },
  { id: 60000702, parentId: 60000007, name: "Card Games",            icon: BookOpen   },

  { id: 60000801, parentId: 60000008, name: "Pool & Snooker",        icon: Trophy     },
  { id: 60000802, parentId: 60000008, name: "Table Games",           icon: Layers     },

  { id: 60000901, parentId: 60000009, name: "Football & Soccer",     icon: Target     },
  { id: 60000902, parentId: 60000009, name: "Basketball",            icon: Trophy     },
  { id: 60000903, parentId: 60000009, name: "Archery & Target Games",icon: Target     },

  { id: 60001001, parentId: 60000010, name: "Educational Games",     icon: BookOpen   },
  { id: 60001002, parentId: 60000010, name: "Family Party Games",    icon: Users      },
];

export const idGamingProducts: CategoryItem[] = [
  { id: 60010101, parentId: 60000101, name: "PlayStation Consoles",   icon: Gamepad2   },
  { id: 60010102, parentId: 60000101, name: "Xbox Consoles",          icon: Gamepad2   },
  { id: 60010103, parentId: 60000101, name: "Nintendo Consoles",      icon: Gamepad2   },

  { id: 60010301, parentId: 60000103, name: "Wireless Controllers",   icon: Joystick   },
  { id: 60010302, parentId: 60000103, name: "Racing Wheels",          icon: Cpu        },

  { id: 60020301, parentId: 60000203, name: "Mechanical Keyboards",   icon: Keyboard   },
  { id: 60020302, parentId: 60000203, name: "Gaming Mice",            icon: Mouse      },
  { id: 60020303, parentId: 60000203, name: "Gaming Monitors",        icon: Monitor    },

  { id: 60040101, parentId: 60000401, name: "Surround Sound Headsets",icon: Headphones },
  { id: 60040102, parentId: 60000401, name: "Gaming Speakers",        icon: Speaker    },

  { id: 60050101, parentId: 60000501, name: "Racing Style Chairs",    icon: Layout     },
  { id: 60050201, parentId: 60000502, name: "RGB Gaming Desks",       icon: Monitor    },

  { id: 60060101, parentId: 60000601, name: "Standalone VR Headsets", icon: Joystick   },
  { id: 60060102, parentId: 60000601, name: "PC VR Systems",          icon: Cpu        },

  { id: 60070101, parentId: 60000701, name: "Strategy Board Games",   icon: Dice5      },
  { id: 60070102, parentId: 60000701, name: "Classic Board Games",    icon: Package    },

  { id: 60090301, parentId: 60000903, name: "Archery Sets",           icon: Target     },
  { id: 60090302, parentId: 60000903, name: "Outdoor Game Kits",      icon: Tent       },
];